import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

// Create badgeVariants function separately for HMR stability
const createBadgeVariants = () =>
	cva(
		"inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400/70 focus:ring-offset-2",
		{
			variants: {
				variant: {
					default:
						"border-transparent bg-gradient-to-br from-blue-500 via-blue-600 to-cyan-600 text-white shadow-[0_10px_20px_-14px_rgba(37,99,235,0.9)] hover:brightness-110",
					secondary:
						"border-transparent bg-slate-100 text-slate-700 hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-200",
					destructive:
						"border-transparent bg-red-100 text-red-700 hover:bg-red-200 dark:bg-red-950/35 dark:text-red-300",
					outline: "border-slate-200/80 bg-white/80 text-slate-700 dark:border-slate-700 dark:bg-slate-900/70 dark:text-slate-200",
				},
			},
			defaultVariants: {
				variant: "default",
			},
		}
	);

export const badgeVariants = createBadgeVariants();

export interface BadgeProps
	extends React.HTMLAttributes<HTMLDivElement>,
		VariantProps<typeof badgeVariants> {}

function BadgeComponent(
	{ className, variant, ...props }: BadgeProps,
	ref: React.Ref<HTMLDivElement>
) {
	return (
		<div
			ref={ref}
			className={cn(badgeVariants({ variant }), className)}
			{...props}
		/>
	);
}

export const Badge = React.forwardRef(BadgeComponent);
Badge.displayName = "Badge";